<template>
  <div>
    <el-dialog :title="eltitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="640px"
      :before-close="returnClick">
      <el-row style="width: 626px;box-sizing: border-box;max-height: 595px;overflow:auto;">
        <div class="seaerch-wrapper">
          <!-- 基本字段 -->
          <el-form :model="modalInfo.basicform" ref="ruleForm" class="add-form" label-position="right"
            label-width="130px">
            <el-form-item v-for="(value, key) in modalInfo.props" :key="key" v-show="value.isChecked"
              :label="value.prop == 'address' ? '详细地址' : value.label" :prop="value.prop"
              v-if="value.fieldClassify == 'basic' && value.isChecked" :rules="value.fieldRequired == 1 ? {
                required: true, message: value.label + '不能为空', trigger: ['blur', 'change']
              } : null">
              <!-- 地址 -->
              <v-distpicker :province="selectArea.province" :city="selectArea.city" :area="selectArea.area"
                v-if="value.prop == 'selectAddress'" @province="onChangeProvince" @city="onChangeCity"
                @area="onChangeArea" style="height: 32px;"></v-distpicker>
              <el-input v-else-if="value.prop == 'address'" v-model.trim="modalInfo.basicform[value.prop]"
                size="small"></el-input>
              <!-- 品牌联系人 -->
              <el-select v-else-if="value.prop == 'brmuserid'"
                v-model="modalInfo.basicform[value.prop]" placeholder="请选择" size="small" clearable>
                {{ modalInfo.basicform[value.prop] }}
                <el-option v-for="item in brmuserData" :key="item.userid" :value="item.userid" :label="item.realname"></el-option>
              </el-select>
              <!-- 经销商层级 -->
              <el-select v-else-if="value.prop == 'level'" @change="changeLevel"
                v-model="modalInfo.basicform[value.prop]" placeholder="请选择" size="small" clearable>
                <el-option v-for="item in levelData" :key="item.level" :value="item.level"
                  :label="item.alias ? item.alias : item.moudle"></el-option>
              </el-select>
              <!--上级经销商-->
              <el-select v-else-if="value.prop == 'hlevelid'" v-model="modalInfo.basicform.hlevelid" filterable
                placeholder="请选择" size="small" clearable>
                <el-option v-for="item in hlevelList" :key="item.id"
                  :disabled="modalInfo.basicform.dealername && modalInfo.basicform.dealername == item.dealername ? true : false"
                  :value="item.id" :label="item.dealername"></el-option>
              </el-select>
              <el-input v-else v-model.trim="modalInfo.basicform[value.prop]" size="small" clearable></el-input>
            </el-form-item>
          </el-form>
          <!-- 新增字段 -->
          <el-form :model="modalInfo.addform" ref="ruleForm2" class="add-form" label-position="right"
            label-width="130px">
            <el-form-item v-for="(value, key) in modalInfo.props" :key="key + '2'" v-show="value.isChecked"
              :label="value.label" :prop="value.prop" v-if="value.fieldClassify == 'add'" :rules="value.fieldRequired == '1' ? {
                required: true, message: value.label + '不能为空', trigger: ['blur', 'change']
              } : null">
              <el-input v-model.trim="modalInfo.addform[value.prop]" size="small" clearable></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" :class="modalInfo.ispanelEdit ? '' : 'confirm'" @click="confirmClick()">确
          定</el-button>
        <el-button size="small" :class="modalInfo.ispanelEdit ? '' : 'cancel'" @click="returnClick">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VDistpicker from 'v-distpicker'; //地区控件
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { mapState, mapActions } from 'vuex';
export default {
  name: "newAddModel",
  components: { VDistpicker },
  props: {
    modalInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      eltitle: '',
      dialogVisible: false,
      addfields: [],
      brmuserData: [],
      selectArea: {
        province: '',
        city: '',
        area: '',
        levelData: []
      }
    };
  },
  computed: {
    ...mapState({
      levelList: state => state.commonList.levelList,
      dealernameList: state => state.commonList.dealernameList
    }),
    hlevelList() {
      return JSON.parse(JSON.stringify(this.dealernameList))
    }
  },
  created() {
    // // 设置地区控件回显
    // console.log(this.modalInfo)
    this.getDealerLevelAlias()
    this.getUseroutChildrenPage()
    if (this.modalInfo.flag == "edit") {
      console.log(this.modalInfo.basicform.level)
      let query = { level: this.modalInfo.basicform.level }
      this.reqDealernameList(query)
      this.modalInfo.basicform.selectAddress = this.modalInfo.basicform.province + this.modalInfo.basicform.city + this.modalInfo.basicform.strict;
      this.selectArea.province = this.modalInfo.basicform.province;
      this.selectArea.city = this.modalInfo.basicform.city;
      this.selectArea.area = this.modalInfo.basicform.strict;
      this.modalInfo.basicform.level = ''
    }
  },
  methods: {
    getDealerLevelAlias() {
      fetch({
        url: "hcm/cus/getDealerLevelAlias",
        method: "post",
      }).then(res => {
        if (res.status == "10000") {
          this.levelData = []
          this.levelData = res.data
        }
      });
    },
    getUseroutChildrenPage() {
      let params = {
        pageNo: 1,
        pageSize: 100
      }
      fetch({
        url: "hcm/userout/getUseroutChildrenPage",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res
        if (res.status == '10000') {
          this.brmuserData = data.content

        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch(err => {
        this.$message.error('接口异常');
      });
    },
    ntm(val) {
      console.log(val)
      if (val.flag == 'edit') {
        this.eltitle = '编辑'
      } else {
        this.eltitle = '新增'
      }
      if (val.flag == 'edit') {
        let query = { level: val.basicform.level }
        this.reqDealernameList(query)
        this.selectArea.province = val.basicform.province;
        this.selectArea.city = val.basicform.city;
        this.selectArea.area = val.basicform.strict;
      }
      this.dialogVisible = true
    },
    ...mapActions(['reqDealernameList']),
    // 获取上级经销商名称和hlevelid
    getDealername(val) {
      let obj = {};
      obj = this.dealernameList.find((item) => {
        return item.id === val;
      });
      this.modalInfo.basicform.dealername = obj.dealername;
    },
    // 选区经销商层级获取上级经销商
    changeLevel(val) {
      let query = { level: val }
      this.reqDealernameList(query)
    },
    // 地区选区取值(省)
    onChangeProvince(a) {
      this.$set(this.modalInfo.basicform, "selectAddress", a.value)
      this.modalInfo.basicform.province = a.value;
    },
    onChangeCity(a) { //(市)
      this.modalInfo.basicform.city = a.value;
      this.modalInfo.basicform.selectAddress = this.modalInfo.basicform.selectAddress + a.value;
    },
    onChangeArea(a) {  //(区)
      this.modalInfo.basicform.strict = a.value;
      this.modalInfo.basicform.selectAddress = this.modalInfo.basicform.selectAddress + a.value;
    },
    addProp(obj, keys) {
      let addField = {}
      for (let i = 0; i < keys.length; i++) {
        if (obj[keys[i]]) {
          addField[keys[i]] = obj[keys[i]]
        }
      }
      return addField
    },
    confirmClick() {
      let addFields = [];
      let addForm = {};
      if (this.modalInfo.addField) {
        for (let item of this.modalInfo.addField) {
          addFields.push(item.prop)
        }
        addForm = this.addProp(this.modalInfo.addform, addFields);//新增字段属性
      }
      let query = {
        ...this.modalInfo.basicform,
        system: "BRM",
        level: this.modalInfo.basicform.level ? this.modalInfo.basicform.level : 1,
        hlevelid: this.modalInfo.basicform.hlevelid ? this.modalInfo.basicform.hlevelid : 0,
        addfield: JSON.stringify(addForm)
      }
      let _this = this;
      _this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$refs.ruleForm2.validate((valid2) => {
            if (valid2) _this.reqNewAdd(query);
            return false;
          })
        } else {
          return false;
        }
      });
    },
    // 新增/编辑请求
    reqNewAdd(query) {
      console.log(query)
      fetch({
        url: "/hcm/dealer/saveDealer",
        method: "post",
        data: query,
        noFormat: true,
        responseType: "text"
      })
        .then(result => {
          let res = JSON.parse(result);
          if (res.status == "10000") {
            this.$message({
              message: "操作成功！",
              type: res.message
            });
            this.dialogVisible = false;
            this.modalInfo.isShow = false;
            this.$emit("reqTableData");
            this.$emit("showEdit", false);
            this.$emit('reqDetail', this.modalInfo.row)
          } else {
            this.$message.error(res.message ? res.message : "操作失败！");
          }
        })
        .catch(err => {
          this.$message.error("请求失败！")
        });
    },
    // 取消
    returnClick() {
      this.$refs.ruleForm.resetFields();
      this.dialogVisible = false;
      this.modalInfo.isShow = false;
      this.$route.query.isClicked = '';
      this.$emit("getIsshow", this.modalInfo.isShow);
      this.$emit("showEdit", false);
    }
  }
};
</script>
<style lang="scss">
.el-dialog__body {
  padding-top: 10px !important;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
}

.distpicker-address-wrapper select {
  height: 32px !important;
  line-height: 32px !important;
  padding: 0 .75rem !important;
}

// .distpicker-address-wrapper {
//   select{
//     height: 32px;
//     line-height: 32px;
//     padding: 0 .75rem;
//   }
// }</style>
